<template>
  <div> 
    <div
      v-if="!(isRetrievingUrl || inValidUrl) && !urlFileName"
      @dragover.prevent @drop.prevent
    >
      <input
        id="fileInput"
        ref="file"
        type="file"
        class="hidden-input"
        accept=".pdf, .html, .docx, .txt"
        multiple="false"
        @change="handleFileUpload"
      />
      <label for="fileInput" class="column upload-card" @drop="dragFile">
        <div v-if="!file" class="full-width">
          <img
            class="row center--img"
            src="/assets/images/sources/folder_arrow_up.svg"
          />
          <span class="row column message-drag">
            {{ $t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.DRAG_AND_DROP') }}
            <b>
              <u>{{
                $t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.BTN_UPLOAD_HERE')
              }}</u>
            </b>
          </span>
          <span class="divider-center">
            {{ $t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.OR') }}
          </span>
          <input
            class="input-url"
            :placeholder="$t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.PLACEHOLDER')"
            @input="$emit('url-change', $event.target.value)"
          />
        </div>
        <div v-else-if="file.id" class="file-label">
          <img
            class="row center--img"
            src="/assets/images/sources/folder-check-outline.png"
          />
          <span class="row column message-drag">
            {{ $t('DOCUMENT_SOURCES.FILE_NAME') }}:
            <b>
              <u>{{ fileName(file) }}</u>
            </b>
          </span>
        </div>
        <div v-else class="file-label">
          <img
            class="row center--img"
            src="/assets/images/sources/folder-check-outline.png"
          />
          <span class="row column message-drag">
            {{ $t('DOCUMENT_SOURCES.FILE_NAME') }}:
            <b>
              <u>{{ fileName(file) }}</u>
            </b>
          </span>
        </div>
      </label>
    </div>
    <div v-else-if="isRetrievingUrl && !inValidUrl">
      <label
        class="column upload-card"
      >
        <div class="file-label">
          <img
            class="row center--img"
            src="/assets/images/sources/folder_clock.svg"
          />
          <span
            class="row column url-title-message"
          >
          {{ $t('DOCUMENT_SOURCES.URL.RETRIEVING_DATA') }}
          </span>
          <span
            class="row column message-drag url-description"
          >
          {{ $t('DOCUMENT_SOURCES.URL.TEXT') }}
            <u>{{ url }}</u>
          </span>
        </div>
      </label>
    </div>
    <div v-else-if="isRetrievingUrl && inValidUrl">
      <label
        class="column upload-card"
      >
        <div>
          <img
            class="row center--img"
            src="/assets/images/sources/folder_cancel.svg"
          />
          <span
            class="row column url-title-message"
          >
          {{ $t('DOCUMENT_SOURCES.URL.INVALID_URL') }}
          </span>
          <span
            class="row column message-drag"
          >
            {{ $t('DOCUMENT_SOURCES.URL.CHECK_AND_RESUBMIT') }}
          </span>
          <span
            class="row column message-drag url-description"
          >
            {{ $t('DOCUMENT_SOURCES.URL.TEXT') }}
            <u>{{ url }}</u>
          </span>
        </div>
      </label>
    </div>
    <div v-if="urlFileName">
      <label
        class="column upload-card"
      >
        <div class="file-label">
          <img
            class="row center--img"
            src="/assets/images/sources/folder_check.svg"
          />
          <span
            class="row column message-drag url-description"
          >
          {{ $t('DOCUMENT_SOURCES.URL.TEXT') }}
            <u>{{ url }}</u>
          </span>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { getFileName } from 'helpers/FileHelper';

export default {
  mixins: [alertMixin],
  props: {
    file: {
      type: [Object, File],
    },
    url: {
      type: String,
      default: '',
    },
    urlFileName: {
      type: String,
      default: '',
    },
    inValidUrl: {
      type: Boolean,
      default: false,
    },
    isRetrievingUrl: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleFileUpload() {
      if (this.$refs.file.files.length) {
        this.$emit('file-change', this.$refs.file.files[0]);
      }
    },
    fileName(file) {
      return getFileName(file);
    },
    dragFile(e) {
      this.$emit('file-change', e.dataTransfer.files[0]);
    }
  },
};
</script>
<style scoped lang="scss">
.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}
.upload-card {
  margin: 0 0 1.6rem;
  padding: var(--space-large);
  border: 1px solid var(--s-75);
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--s-25);
  text-align: center;
  height: var(--space-giga);
}
.modal-footer {
  .button {
    margin-right: var(--space-small);
    margin-left: 0;
  }
}
.center--img {
  margin: auto;
  height: var(--space-jumbo);
}
.message-drag {
  color: var(--w-500);
  u {
    cursor: pointer;
  }
}

.url-title-message {
  font-size: 20px;
  font-weight: bold;
  color: var(--w-500);
}

.url-description {
  margin-top: 1rem;
}

.input-url {
  border-radius: var(--border-radius-full);
  width: 100%;
  border: 1px solid var(--s-200);
  padding: var(--space-small);
  padding-left: var(--space-two);
}
.divider-center {
  padding: var(--space-small);
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
}
.divider-center::after,
.divider-center::before {
  flex: 1 1 0%;
  border-top: var(--space-micro) solid rgba(231, 234, 243, 0.7);
  content: '';
  display: block;
}
.divider-center::after {
  margin-left: var(--space-two);
}
.divider-center::before {
  margin-right: var(--space-two);
}
.full-width {
  width: 100%;
}
.file-label {
  padding-top: var(--space-large);
  padding-bottom: var(--space-large);
  width: 90%;
}
</style>
